import React from 'react'
import { Component } from 'react';
import authService from './AuthorizeService';
import { AuthenticationResultStatus } from './AuthorizeService';
import { Text, ITextProps } from '@fluentui/react/lib/Text';
import { Spinner } from '@fluentui/react/lib/Spinner';
import { Separator } from '@fluentui/react/lib/Separator';
import { getTheme } from "@fluentui/style-utilities";
import { QueryParameterNames, LogoutActions, ApplicationPaths } from './ApiAuthorizationConstants';


// The main responsibility of this component is to handle the user's logout process.
// This is the starting point for the logout process, which is usually initiated when a
// user clicks on the logout button on the LoginMenu component.
export class Logout extends Component {
    constructor(props) {
        super(props);

        this.state = {
            message: undefined,
            isReady: false,
            authenticated: false
        };
    }

    componentDidMount() {
        const action = this.props.action;
        switch (action) {
            case LogoutActions.Logout:
                if (!!window.history.state.state.local) {
                    this.logout(this.getReturnUrl());
                } else {
                    // This prevents regular links to <app>/authentication/logout from triggering a logout
                    this.setState({ isReady: true, message: "The logout was not initiated from within the page." });
                }
                break;
            case LogoutActions.LogoutCallback:
                this.processLogoutCallback();
                break;
            case LogoutActions.LoggedOut:
                this.setState({ isReady: true, message: "You successfully logged out!" });
                break;
            default:
                throw new Error(`Invalid action '${action}'`);
        }

        this.populateAuthenticationState();
    }

    render() {
        const theme = getTheme();
        const loginPath = `${ApplicationPaths.Login}`;
        const appPath = `${ApplicationPaths.Login}`;
        const { userData } = this.state;
        const protocol = `${window.location.protocol}`;
        const hostName = `${window.location.hostname}`;
        const port = `${window.location.port}`;

        const { isReady, message } = this.state;
        if (!isReady) {
            return <div></div>
        }
        if (!!message) {
            return (<div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                        <Separator alignContent="start"></Separator>
                        <div>
                            <p>
                                <strong>{message}</strong>
                            </p>
                        </div>
                <div><p><a href={protocol + "//" + hostName + ":" + port + "/Account/Login?isReferral=False"} >Login to submit a F7 Notice of upcoming Collective Bargaining or to Request other FMCS Services</a> <a href="https://www.fmcs.gov/aboutus/agency-departments/office-of-field-operations-regional/office-of-client-services/">(learn more about the services we offer)</a></p></div>
                <div><a href={protocol + "//" + hostName + ":" + port + "/Account/Login?isReferral=True"} >Login to submit a Referral for an Inter-Agency Agreement</a> <a href="https://www.fmcs.gov/aboutus/agency-departments/office-of-field-operations-national/ocmp/">(learn more about creating an Inter-Agency Agreement with FMCS)</a></div>
                    </div>);
        } else {
            const action = this.props.action;
            switch (action) {
                case LogoutActions.Logout:
                    return (<div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                                <Separator alignContent="start"></Separator>
                                <div>
                                    <Spinner label="Processing logout..." ariaLive="assertive" labelPosition="top" />
                                </div>
                            </div>);
                case LogoutActions.LogoutCallback:
                    return (<div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                                <Separator alignContent="start"></Separator>
                                <div>
                                    <Spinner label="Processing logout..." ariaLive="assertive" labelPosition="top" />
                                </div>
                            </div>);
                case LogoutActions.LoggedOut:
                    return (<div style={{ boxShadow: theme.effects.elevation8, backgroundColor: "white", padding: "15px", marginBottom: "20px" }}>
                                <Separator alignContent="start"></Separator>
                                <div>
                                    {message}
                                </div>
                            </div>);
                default:
                    throw new Error(`Invalid action '${action}'`);
            }
        }
    }

    async logout(returnUrl) {
        const state = { returnUrl };
        const isauthenticated = await authService.isAuthenticated();
        if (isauthenticated) {
            const result = await authService.signOut(state);
            switch (result.status) {
                case AuthenticationResultStatus.Redirect:
                    break;
                case AuthenticationResultStatus.Success:
                    await this.navigateToReturnUrl(returnUrl);
                    break;
                case AuthenticationResultStatus.Fail:
                    this.setState({ message: result.message });
                    break;
                default:
                    throw new Error("Invalid authentication result status.");
            }
        } else {
            this.setState({ message: "You successfully logged out!" });
        }
    }

    async processLogoutCallback() {
        const url = window.location.href;
        const result = await authService.completeSignOut(url);
        switch (result.status) {
            case AuthenticationResultStatus.Redirect:
                // There should not be any redirects as the only time completeAuthentication finishes
                // is when we are doing a redirect sign in flow.
                throw new Error('Should not redirect.');
            case AuthenticationResultStatus.Success:
                await this.navigateToReturnUrl(this.getReturnUrl(result.state));
                break;
            case AuthenticationResultStatus.Fail:
                this.setState({ message: result.message });
                break;
            default:
                throw new Error("Invalid authentication result status.");
        }
    }

    async populateAuthenticationState() {
        const authenticated = await authService.isAuthenticated();
        this.setState({ isReady: true, authenticated });
    }

    getReturnUrl(state) {
        const params = new URLSearchParams(window.location.search);
        const fromQuery = params.get(QueryParameterNames.ReturnUrl);
        if (fromQuery && !fromQuery.startsWith(`${window.location.origin}/`)) {
            // This is an extra check to prevent open redirects.
            throw new Error("Invalid return url. The return url needs to have the same origin as the current page.")
        }
        return (state && state.returnUrl) ||
            fromQuery ||
            `${window.location.origin}${ApplicationPaths.LoggedOut}`;
    }

    navigateToReturnUrl(returnUrl) {
        return window.location.replace(returnUrl);
    }
}
